import { parseHostname } from '@ta-interaktiv/parse-hostname'
import LOCALES from 'locales/locales.js'

type Message = {
  [key: string]: string
}

type Languages = 'fr' | 'de'

export const useLocales = () => {
  const publicationName = parseHostname().publicationName
  const locales: Map<string, Languages> = new Map([
    ['24heures', 'fr'],
    ['tdg', 'fr'],
    ['tagesanzeiger', 'de'],
    ['bernerzeitung', 'de']
  ])
  const locale: Languages = locales.get(publicationName) || 'de'
  const messages: Message = Object.entries(LOCALES).reduce(
    (a, b) => ({ [b[0]]: b[1][locale], ...a }),
    {}
  )

  return {
    locale: locale,
    messages: messages
  }
}
